import { NpcLink } from "../npc/NpcLink";

export function QuestStartNPCList(props: {
  startNpcs: {
    type?: string | null;
    npcName: string;
    name: string;
    level?: number | null;
    nick: string;
    nickColor: "default" | "quest" | "raid";
    race?: {
      icon?: string;
    };
  }[];
  separator?: boolean;
}) {
  const separator = props.separator ?? false;
  return (
    <>
      {props.startNpcs.map((starter, i) => (
        <div
          key={i}
          style={separator ? { display: "inline-block" } : { display: "block" }}
        >
          <NpcLink npc={starter} showLvl={false} />
          {separator && i < props.startNpcs.length - 1 ? ", " : ""}
        </div>
      ))}
    </>
  );
}
